import { render, staticRenderFns } from "./LearningSuitcaseView.vue?vue&type=template&id=671f6d72&scoped=true"
import script from "./LearningSuitcaseView.vue?vue&type=script&lang=js"
export * from "./LearningSuitcaseView.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=671f6d72&prod&scoped=true&lang=css&external"
import style1 from "./LearningSuitcaseView.vue?vue&type=style&index=1&id=671f6d72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671f6d72",
  null
  
)

export default component.exports